import { useTranslation } from 'react-i18next';

import { useMixpanelTrack, useWorkspace } from '@treams/treams-hooks';
import { Button } from '@treams/treams-ui';

import ProductLayout from './ProductLayout';

export default function WorkspaceNotFound(props: { employee?: boolean; modal?: boolean }) {
	const { t } = useTranslation();
	const workspace = useWorkspace();

	useMixpanelTrack('/workspace-not-found');

	return (
		<ProductLayout
			modal={props.modal}
			title={t('workspace.notFound.title')}
			cta={
				<Button
					type="primary"
					title="Neem contact op"
					onClick={() => {
						(window as any).$crisp.push(['do', 'chat:open']);
						(window as any).$crisp.push([
							'set',
							'message:text',
							[
								t('workspace.notFound.chat.placeholder', {
									workspaceID: workspace.id,
								}),
							],
						]);
					}}
				/>
			}
		>
			<p>{t('workspace.notFound.subtitle')}</p>
			<p>{t('workspace.notFound.instruction')}</p>
		</ProductLayout>
	);
}
